<div 
     [ngStyle]="{'width': maxWidth ? null : '100%',
                 'max-width': maxWidth ? maxWidth+'px' : '100%',
                 'padding': padding+'px', 
                 'margin': margin+'px',
                 'background-color': appearance.cards.bgColor,
                 'border': appearance.cards.border,
                 'border-radius': appearance.cards.borderRadius,
                 'box-shadow': appearance.cards.shadow ? null : 'none'
                }">
    <ng-content></ng-content>
</div>
